/* ============================================================
   SENPAI DRIP — cart photo rotation
   assets/sd-cart-rotate.js
   Each bag item's thumbnail (cart drawer + /cart page):
   photo 1 = the photo set for the colour in the bag,
   photos 2 + 3 = the next photos after it in the product gallery,
   then repeat. Never crosses into another colour's photos.
   Size charts / guides skipped. Shipping protection ignored.
   Pauses on touch, hover, closed drawer, hidden tab.
   Reduced motion = photo stays still.
   ============================================================ */
(function () {
  'use strict';
  if (window.__sdCartRotate) return;
  window.__sdCartRotate = true;

  /* ── SETTINGS — change these ───────────────────────────── */
  var CFG = {
    every: 3000,     // ms each photo stays on screen
    fade: 800,       // ms for the swap animation
    stagger: 650,    // ms gap between items so they don't all flip together
    resume: 4000,    // ms after a touch before rotating again
    photos: 3,       // colour photo + the next 2 in the gallery
    width: 300,      // photo width requested from Shopify's CDN
    dots: true       // photo dots under each thumbnail
  };
  /* ──────────────────────────────────────────────────────── */

  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!Element.prototype.animate) return;

  var PROT = [47319584669730, 47319584702498];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SKIP_ALT = /\bsize\b|chart|guide|measure/i;
  var SKIP_FILE = /size[\s_-]*(chart|guide)|chart|measure/i;

  var TARGETS = [
    { item: '#cart-drawer li.cart-items-product', box: '.cart-item-img', img: 'img.cart-item__image', where: 'drawer' },
    { item: '.sd-ct__item', box: '.sd-ct__thumb', img: 'img', where: 'page' }
  ];

  /* ---------- styles (layer is a span, so no theme img rules touch it) ---------- */
  var css = document.createElement('style');
  css.textContent =
    '.sd-rot__l{position:absolute;z-index:1;pointer-events:none;opacity:0;box-sizing:border-box;' +
      'background-repeat:no-repeat;background-position:center;background-origin:content-box;background-clip:content-box;' +
      'will-change:opacity,transform,filter}' +
    '.sd-rot__dots{position:absolute;left:0;right:0;bottom:5px;z-index:2;display:flex;justify-content:center;gap:3px;pointer-events:none}' +
    '.sd-rot__dots i{display:block;width:4px;height:4px;border-radius:99px;background:rgba(237,231,218,.55);' +
      'box-shadow:0 0 0 1px rgba(11,11,12,.35);transition:width .55s cubic-bezier(.34,1.56,.64,1),background-color .3s ease,box-shadow .3s ease}' +
    '.sd-rot__dots i.on{width:12px;background:#B4141B;box-shadow:0 0 6px rgba(180,20,27,.7)}';
  document.head.appendChild(css);

  /* ---------- helpers ---------- */
  function abs(u) { u = String(u || ''); return u.indexOf('//') === 0 ? 'https:' + u : u; }
  function sized(u) {
    u = abs(u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + CFG.width;
  }
  function key(u) { return String(abs(u).split('?')[0].split('/').pop() || '').toLowerCase(); }

  /* ---------- product data (cached 30 min per tab) ---------- */
  var pcache = {};
  function product(handle) {
    if (pcache[handle]) return pcache[handle];
    var sk = 'sd_rot2_' + handle;
    try {
      var c = JSON.parse(sessionStorage.getItem(sk) || 'null');
      if (c && Date.now() - c.t < 18e5) return (pcache[handle] = Promise.resolve(c.p));
    } catch (e) {}
    pcache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var slim = {
          media: (p.media || []).filter(function (m) { return m.media_type === 'image' && m.src; })
                                .map(function (m) { return { src: m.src, alt: m.alt || '' }; }),
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, img: v.featured_image ? v.featured_image.src : '' };
          })
        };
        if (!slim.media.length) slim.media = (p.images || []).map(function (s) { return { src: s, alt: '' }; });
        try { sessionStorage.setItem(sk, JSON.stringify({ t: Date.now(), p: slim })); } catch (e) {}
        return slim;
      })
      .catch(function () { delete pcache[handle]; return null; });
    return pcache[handle];
  }

  /* ---------- colour photo first, then the next photos in the gallery ---------- */
  function pick(p, vid, lineImg) {
    var media = p.media.filter(function (m) { return !SKIP_ALT.test(m.alt) && !SKIP_FILE.test(key(m.src)); });
    var v = null;
    p.variants.forEach(function (x) { if (x.id === vid) v = x; });

    var mine = key((v && v.img) || lineImg);

    /* every OTHER colour's own photo marks where that colour's photos begin → stop there */
    var stops = {};
    p.variants.forEach(function (x) { if (x.img && key(x.img) !== mine) stops[key(x.img)] = 1; });

    var start = -1;
    media.forEach(function (m, i) { if (start < 0 && key(m.src) === mine) start = i; });

    var out = [abs(start > -1 ? media[start].src : lineImg)];
    if (!out[0]) return [];
    for (var i = start + 1; i < media.length && out.length < CFG.photos; i++) {
      var k = key(media[i].src);
      if (stops[k]) break;          /* next colour starts — don't borrow its photos */
      if (k === mine) continue;
      out.push(abs(media[i].src));
    }
    return out;
  }

  /* ---------- rotation ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { var s = e.target.__sdRot; if (s) s.vis = e.isIntersecting; });
  }) : null;

  function warm(u) { if (!u) return; var im = new Image(); im.decoding = 'async'; im.src = sized(u); }
  function dot(s, n) { if (!s.dots) return; var d = s.dots.children; for (var i = 0; i < d.length; i++) d[i].className = i === n ? 'on' : ''; }
  function kill(s) { clearTimeout(s.t); s.dead = true; if (io) io.unobserve(s.box); }
  function schedule(s, wait) {
    clearTimeout(s.t);
    s.t = setTimeout(function () { step(s); }, wait == null ? CFG.every : wait);
    warm(s.list[(s.i + 1) % s.list.length]);
  }

  function step(s) {
    if (s.dead) return;
    if (!s.el.isConnected) return kill(s);
    if (document.hidden || !s.vis || s.hold > Date.now()) return schedule(s, 700);

    var n = (s.i + 1) % s.list.length, url = sized(s.list[n]);
    var pre = new Image();
    pre.onload = function () { swap(s, n, url); };
    pre.onerror = function () {
      s.list.splice(n, 1);
      if (s.dots && s.dots.children[n]) s.dots.removeChild(s.dots.children[n]);
      if (s.list.length < 2) { kill(s); if (s.dots) s.dots.remove(); return; }
      if (s.i >= s.list.length) s.i = 0;
      schedule(s);
    };
    pre.src = url;
  }

  function swap(s, n, url) {
    if (s.dead || !s.el.isConnected) return kill(s);
    if (s.hold > Date.now()) return schedule(s, 700);

    var img = s.img, L = s.layer, cs = getComputedStyle(img), fit = cs.objectFit;
    L.style.left = img.offsetLeft + 'px';
    L.style.top = img.offsetTop + 'px';
    L.style.width = img.offsetWidth + 'px';
    L.style.height = img.offsetHeight + 'px';
    L.style.padding = cs.padding;
    L.style.borderRadius = cs.borderRadius;
    L.style.backgroundSize = fit === 'cover' ? 'cover' : (fit === 'fill' ? '100% 100%' : 'contain');
    L.style.backgroundPosition = cs.objectPosition || 'center';
    L.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';

    var dir = n > s.i ? 1 : -1;   /* looping back to photo 1 swings the other way */
    dot(s, n);

    var aIn = L.animate([
      { opacity: 0, transform: 'perspective(500px) rotateY(' + (-18 * dir) + 'deg) translateX(' + (8 * dir) + '%) scale(1.06)', filter: 'blur(5px)' },
      { opacity: 1, transform: 'none', filter: 'blur(0px)' }
    ], { duration: CFG.fade, easing: 'cubic-bezier(.34,1.32,.64,1)', fill: 'forwards' });

    var aOut = img.animate([
      { opacity: 1, transform: 'none' },
      { opacity: 0, transform: 'perspective(500px) rotateY(' + (14 * dir) + 'deg) translateX(' + (-6 * dir) + '%) scale(.94)' }
    ], { duration: CFG.fade * 0.7, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });

    aIn.onfinish = function () {
      var finished = false;
      var done = function () {
        if (finished) return; finished = true;
        aOut.cancel(); aIn.cancel();          /* same photo under the layer → seamless hand-off */
        s.i = n;
        schedule(s);
      };
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = url;
      if (img.decode) img.decode().then(done, done);
      else if (img.complete) done();
      else { img.onload = done; img.onerror = done; }
      setTimeout(done, 2500);                  /* safety net */
    };
  }

  function bind(el, box, img, list, idx) {
    if (list.length < 2) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.style.overflow = 'hidden';

    var layer = document.createElement('span');
    layer.className = 'sd-rot__l';
    layer.setAttribute('aria-hidden', 'true');
    box.appendChild(layer);

    var dots = null;
    if (CFG.dots) {
      dots = document.createElement('span');
      dots.className = 'sd-rot__dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = list.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('');
      box.appendChild(dots);
    }

    var s = { el: el, box: box, img: img, layer: layer, dots: dots, list: list, i: 0, hold: 0, vis: true, t: 0, dead: false };
    box.__sdRot = s;
    if (io) io.observe(box);

    /* make sure photo 1 really is the colour photo */
    if (key(img.currentSrc || img.src) !== key(list[0])) { img.removeAttribute('srcset'); img.src = sized(list[0]); }

    /* touch pauses (never fights swipe-to-delete); mouse hover pauses */
    var holdOn = function () { s.hold = Infinity; };
    var holdOff = function () { s.hold = Date.now() + CFG.resume; };
    el.addEventListener('pointerdown', holdOn, { passive: true });
    el.addEventListener('pointerup', holdOff, { passive: true });
    el.addEventListener('pointercancel', holdOff, { passive: true });
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') holdOn(); });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' || s.hold === Infinity) holdOff(); });

    schedule(s, CFG.every + idx * CFG.stagger);
  }

  /* ---------- find bag items (re-runs after every drawer re-render) ---------- */
  var scanning = false, again = false;
  function scan() {
    if (scanning) { again = true; return; }
    var jobs = [];
    TARGETS.forEach(function (T) {
      Array.prototype.forEach.call(document.querySelectorAll(T.item), function (el, i) {
        if (el.__sdRotDone) return;
        var box = el.querySelector(T.box), img = box && box.querySelector(T.img);
        if (!box || !img) return;
        el.__sdRotDone = true;
        jobs.push({ T: T, el: el, box: box, img: img, i: i });
      });
    });
    if (!jobs.length) return;

    scanning = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var real = (cart.items || []).filter(function (it) { return PROT.indexOf(it.variant_id) < 0; });
        return Promise.all(jobs.map(function (j, n) {
          var line = null;
          if (j.T.where === 'drawer') {
            var k = j.el.getAttribute('data-sd-key'), vid = +j.el.getAttribute('data-sd-vid');
            real.forEach(function (it) { if (!line && it.key === k) line = it; });
            if (!line) real.forEach(function (it) { if (!line && it.variant_id === vid) line = it; });
          } else {
            line = real[j.i];
          }
          if (!line || !line.handle) return;
          return product(line.handle).then(function (p) {
            if (!p || !j.el.isConnected) return;
            bind(j.el, j.box, j.img, pick(p, line.variant_id, line.image), n);
          });
        }));
      })
      .catch(function () {})
      .then(function () { scanning = false; if (again) { again = false; scan(); } });
  }

  var mt;
  new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(scan, 300); })
    .observe(document.body, { childList: true, subtree: true });

  scan();
})();